import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import AuthService from '../../../services/auth.service';
import UserService from '../../../services/user.service';
import * as log from '../../../utils/log';
import { filterOutAction } from '../Guild/slice';
export var AccountType;
(function (AccountType) {
    AccountType["USER_NAME"] = "userName";
    AccountType["IMAGE"] = "image";
    AccountType["ME"] = "me";
    AccountType["CHECK_NAME"] = "checkName";
    AccountType["userInfo"] = "";
    AccountType["localAvatar"] = "";
})(AccountType || (AccountType = {}));
export const getMe = createAsyncThunk('users/me', async () => {
    return await UserService.getMe().then((response) => response.data);
});
export const getImages = createAsyncThunk('users/images', async () => {
    return await UserService.getImages().then((response) => response.data);
});
export const setUserAvatar = createAsyncThunk('users/setAvatar', async (filename) => {
    return await UserService.setAvatar(filename).then((res) => res);
});
export const getUserAddress = createAsyncThunk('users/address', async (stakeId) => {
    return await UserService.getUserByAddress(stakeId).then((response) => response.data);
});
export const uploadImage = createAsyncThunk('users/image', async (image) => {
    try {
        return await AuthService.uploadPhoto(image);
    }
    catch (err) {
        if (axios.isAxiosError(err)) {
            return err.response;
        }
    }
});
export const deleteImage = createAsyncThunk('delete/users/image', async () => {
    try {
        return await AuthService.deletePhoto();
    }
    catch (err) {
        if (axios.isAxiosError(err)) {
            return err.response;
        }
    }
});
export const setUserName = createAsyncThunk('users', async (name) => {
    try {
        return await AuthService.setUserName(name);
    }
    catch (err) {
        if (axios.isAxiosError(err)) {
            return err.response;
        }
    }
});
export const checkName = createAsyncThunk('users/check-name', async (name) => {
    try {
        return await AuthService.checkName(name);
    }
    catch (err) {
        return err.response;
    }
});
export const initialState = {
    userInfo: null,
    localAvatar: '',
    error: null,
    pending: [],
    appInitialLoading: false,
    visitedStableUserId: ''
};
const setUserInfo = (state, action) => {
    state.userInfo = action.payload;
    state.pending = filterOutAction(state.pending, AccountType.ME);
};
export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        onAppInitialLoadStarted: (state) => {
            state.appInitialLoading = true;
        },
        onAppInitialLoadCompleted: (state) => {
            state.appInitialLoading = false;
        },
        setAvatarLocally: (state, { payload }) => {
            state.userInfo.photo = payload;
            state.localAvatar = payload;
        },
        resetError: (state) => {
            state.error = null;
        },
        setVisitedStableUserId: (state, { payload }) => {
            state.visitedStableUserId = payload.userId;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getMe.fulfilled, setUserInfo);
        builder.addCase(getMe.pending, (state) => {
            state.pending.push(AccountType.ME);
        });
        builder.addCase(getMe.rejected, (state) => {
            state.userInfo = null;
            state.pending = filterOutAction(state.pending, AccountType.ME);
        });
        builder.addCase(getUserAddress.fulfilled, (state, { payload }) => {
            state.visitedStableUserId = payload.id;
        });
        builder.addCase(getUserAddress.rejected, (state) => {
            state.visitedStableUserId = '';
        });
        builder.addCase(getImages.fulfilled, (state, action) => {
            log.debug(action.payload.data);
        });
        builder.addCase(getImages.pending, (state) => {
            log.debug('getImages - Pending');
        });
        builder.addCase(getImages.rejected, (state) => {
            log.debug('getimages - Error');
        });
        builder.addCase(setUserAvatar.fulfilled, (state, action) => {
            state.userInfo = action.payload.data;
        });
        builder.addCase(setUserAvatar.pending, (state) => {
            log.debug('setUserAvatar - Pending');
        });
        builder.addCase(setUserAvatar.rejected, (state) => {
            log.debug('setUserAvatar - Error');
        });
        builder.addCase(uploadImage.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, AccountType.IMAGE);
            if (action.payload.status === 200) {
                state.userInfo = action.payload.data;
                toast.success('Image uploaded!');
            }
        });
        builder.addCase(uploadImage.pending, (state) => {
            state.pending.push(AccountType.IMAGE);
        });
        builder.addCase(uploadImage.rejected, (state) => {
            state.pending = filterOutAction(state.pending, AccountType.IMAGE);
        });
        builder.addCase(deleteImage.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, AccountType.IMAGE);
            if (action.payload.status === 200) {
                state.userInfo = action.payload.data;
                toast.success('Image deleted!');
            }
        });
        builder.addCase(deleteImage.pending, (state) => {
            state.pending.push(AccountType.IMAGE);
        });
        builder.addCase(deleteImage.rejected, (state) => {
            state.pending = filterOutAction(state.pending, AccountType.IMAGE);
        });
        builder.addCase(setUserName.fulfilled, (state, action) => {
            state.pending = filterOutAction(state.pending, AccountType.USER_NAME);
            if (action.payload.status === 200) {
                state.userInfo = action.payload.data;
                toast.success('User name added!');
            }
        });
        builder.addCase(setUserName.pending, (state) => {
            state.pending.push(AccountType.USER_NAME);
        });
        builder.addCase(setUserName.rejected, (state) => {
            state.pending = filterOutAction(state.pending, AccountType.USER_NAME);
        });
        builder.addCase(checkName.fulfilled, (state, action) => {
            var _a, _b, _c;
            state.pending = filterOutAction(state.pending, AccountType.CHECK_NAME);
            if (action.payload.status === 200) {
                state.error = null;
            }
            if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.status) !== 200 && 'details' in ((_b = action.payload) === null || _b === void 0 ? void 0 : _b.data)) {
                state.error =
                    ((_c = action.payload) === null || _c === void 0 ? void 0 : _c.data.details.replace('name', action.meta.arg)) || null;
            }
        });
        builder.addCase(checkName.pending, (state) => {
            state.pending.push(AccountType.CHECK_NAME);
            state.error = null;
        });
        builder.addCase(checkName.rejected, (state) => {
            state.pending = filterOutAction(state.pending, AccountType.CHECK_NAME);
        });
    }
});
export const { onAppInitialLoadStarted, onAppInitialLoadCompleted, resetError, setAvatarLocally, setVisitedStableUserId } = appSlice.actions;
export default appSlice.reducer;
